/**
 * Campaign Schedule API (Redaktionsplan)
 *
 * Plan/unplan campaign launches and fetch the per-account timetable —
 * same backend source of truth as the chat's schedule card.
 */

import { API_V1 } from './APIs/APIv1';

export interface ScheduleEntry {
  campaignId: string;
  name: string;
  accountId: string;
  state: 'scheduled' | 'running' | 'finished';
  scheduledStartAt: string | null;
  estimatedEndDate: string | null;
  openContacts?: number;
  finishedAt?: string;
}

export interface AccountTimeline {
  accountId: string;
  accountName: string;
  accountStatus: string;
  freeFrom: string | null;
  entries: ScheduleEntry[];
  conflicts: string[];
}

export const getCampaignSchedule = async (): Promise<{ timeline: AccountTimeline[] }> => {
  const response = await API_V1.get('/campaigns/schedule');
  return response.data;
};

export const scheduleCampaignStart = async (
  campaignId: string,
  startAt: string
): Promise<{ campaignId: string; scheduledStartAt: string }> => {
  const response = await API_V1.post(`/campaigns/${campaignId}/schedule`, { startAt });
  return response.data;
};

export const cancelCampaignSchedule = async (campaignId: string): Promise<{ campaignId: string }> => {
  const response = await API_V1.delete(`/campaigns/${campaignId}/schedule`);
  return response.data;
};
